import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthStateService } from '../../services/authstate.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthData } from '../../interfaces/generic.interface';
import { SelectModule } from 'primeng/select';
import { RouterLink } from '@angular/router';
import { CheckboxModule } from 'primeng/checkbox';
import { NotificationsService } from '../../services/notifications.service';

@Component({
  selector: 'app-signup-screen',
  imports: [
    CommonModule,
    FormsModule,
    FloatLabelModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    TranslocoDirective,
    SelectModule,
    RouterLink,
    CheckboxModule
  ],
  templateUrl: './signup-screen.component.html',
  styleUrl: './signup-screen.component.scss'
})
export class SignupScreenComponent {

  mediumRegex = '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})';
  strongRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&#])(?=.{8,})';

  constructor(
    private authService: AuthenticationService,
    private authState: AuthStateService,
    private notifications: NotificationsService
  ) {
  }

  authData: AuthData = {}
  consents = {
    privacyPolicy: false
  }

  signup() {
    if (!this.passwordCheck) {
      this.notifications.showNotification({
        severity: "warn",
        title: "passwordNotSafe",
        detail: "passwordRequisites"
      })
      return
    }
    if (this.authData.username !== undefined && this.authData.password !== undefined) {
      this.authService.performSignup({ ...this.authData, consents: this.consents });
    }
  }

  get passwordCheck() {
    return this.authData.password !== undefined && this.authData.password.match(this.strongRegex);
  }
}
